// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
  GoogleAuthProvider,
  FacebookAuthProvider,
} from "firebase/auth";
import { getStorage } from "firebase/storage"; // Import storage

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDH7muUmDWe27MRw6jXLEksj72Xt2bQnfs",
  authDomain: "wrytte-app.firebaseapp.com",
  projectId: "wrytte-app",
  storageBucket: "wrytte-app.firebasestorage.app",
  messagingSenderId: "25373116138",
  appId: "1:25373116138:web:b820dc9a80319df4d7b993",
  measurementId: "G-0BEJ15R238"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app); // Initialize and export storage
export const analytics = getAnalytics(app); // Initialize and export storage

// Auth providers for popup/redirect sign-in
export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();

/**
 * Sets Firebase Auth persistence.
 * @param {'local' | 'session'} mode - 'local' persists across browser restarts/tabs,
 *   'session' clears when the tab/browser closes.
 */
export async function setAuthPersistence(mode = 'local') {
  await setPersistence(auth, mode === 'session' ? browserSessionPersistence : browserLocalPersistence);
}

/**
 * Logs a custom analytics event.
 * @param {string} eventName - e.g. 'select_content', 'search', 'sign_up'
 * @param {object} [eventParams] - optional key/value params for the event
 */
export function logAnalyticsEvent(eventName, eventParams) {
  if (!analytics) return;
  logEvent(analytics, eventName, eventParams);
}